import { gql } from '@apollo/client';

export const GET_DRAFT_CONTENT_HISTORY = gql`
  query GetDraftContentHistory($input: GetDraftContentHistoryInput!) {
    getDraftContentHistory(input: $input) {
      drafts {
        id
        action
        date
        slideNumber
        subSlideNumber
        componentType
        restoreDraftDate
        sectionId
        templateId
        templateGroup
        templateName
        user {
          id
          emeji
          firstName
          lastName
        }
      }
    }
  }
`;
